import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../app/axiosBaseQuery';

export const investmentsApi = createApi({
  reducerPath: 'investmentsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Investment', 'MyInvestments'],
  endpoints: (builder) => ({
    listInvestments: builder.query({
      query: (params) => ({ url: '/admin/investments', method: 'GET', params }),
      providesTags: (result) =>
        result
          ? [...result.data.map((i) => ({ type: 'Investment', id: i.id })), { type: 'Investment', id: 'LIST' }]
          : [{ type: 'Investment', id: 'LIST' }],
    }),
    getInvestment: builder.query({
      query: (id) => ({ url: `/admin/investments/${id}`, method: 'GET' }),
      providesTags: (result, error, id) => [{ type: 'Investment', id }],
    }),
    createInvestment: builder.mutation({
      query: (body) => ({ url: '/admin/investments', method: 'POST', data: body }),
      invalidatesTags: [{ type: 'Investment', id: 'LIST' }],
    }),
    updateInvestment: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/admin/investments/${id}`, method: 'PUT', data: body }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Investment', id }],
    }),
    updateInvestmentRate: builder.mutation({
      query: ({ id, monthly_interest_rate, reason }) => ({
        url: `/admin/investments/${id}/rate`,
        method: 'PATCH',
        data: { monthly_interest_rate, reason },
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Investment', id }],
    }),
    updateInvestmentStatus: builder.mutation({
      query: ({ id, status }) => ({ url: `/admin/investments/${id}/status`, method: 'PATCH', data: { status } }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Investment', id }],
    }),
    deleteInvestment: builder.mutation({
      query: (id) => ({ url: `/admin/investments/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'Investment', id: 'LIST' }],
    }),
    myInvestments: builder.query({
      query: () => ({ url: '/me/investments', method: 'GET' }),
      providesTags: ['MyInvestments'],
    }),
    // Investor subscribes to a plan — creates a pending investment awaiting funding.
    subscribeInvestment: builder.mutation({
      query: (body) => ({ url: '/investments', method: 'POST', data: body }),
      invalidatesTags: ['MyInvestments', { type: 'Investment', id: 'LIST' }],
    }),
  }),
});

export const {
  useListInvestmentsQuery,
  useGetInvestmentQuery,
  useCreateInvestmentMutation,
  useUpdateInvestmentMutation,
  useUpdateInvestmentRateMutation,
  useUpdateInvestmentStatusMutation,
  useDeleteInvestmentMutation,
  useMyInvestmentsQuery,
  useSubscribeInvestmentMutation,
} = investmentsApi;
